import { Directive, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

@Directive({
  	selector: '[onClickOutside]'
})
export class OnClickOutsideDirective {

	@Output() onClickOutside = new EventEmitter<void>();

	@HostListener('document:click', ['$event.target']) onClick(target) {

        const isNotInChildren: boolean = !this.elementRef.nativeElement.contains(target);
        const isNotInCdkOverlay: boolean = !document.querySelector('.cdk-overlay-container').contains(target);
        const isInInjectedDialogComponent: boolean = target.closest('.mat-dialog-component') !== null;

		if(isNotInChildren && (isNotInCdkOverlay || isInInjectedDialogComponent))
			this.onClickOutside.emit();
	}

	constructor(private elementRef: ElementRef) {}
}
